import React from 'react';
import { Home } from '@mozioinc/transfer-widgets';
import SearchBlock from './sections/SearchBlock';
import posthog from 'posthog-js';
import { HomePageProvider } from '../HomePageContext';

class HomePage extends React.Component {
  componentDidMount() {
    posthog.capture('Homepage Viewed');
  }
  render() {
    return (
      <HomePageProvider>
        <Home>
          <SearchBlock />
        </Home>
      </HomePageProvider>
    );
  }
}

export default HomePage;
